module.exports = __webpack_public_path__ + "img/dog3.4b7d4a92.png";